export default __webpack_public_path__ + "static/media/teacher-fail.ce7f1941.png";